import axios from "axios";
import { TOKEN_NAME } from "configs/constants";
import Cookies from "universal-cookie";
import { buildFirstLevelFilterPoolExport } from "./util";

const baseURL = window.REACT_APP_API_ENDPOINT;

/**
 * @name | refreshPackagesV2
 * @param filterValues | Data to filter
 * @param setAxiosPackageList | Hook to set package data
 */
export const refreshPackagesV2 = async (
  filterValues,
  page,
  pageSize,
  setAxiosPackageList,
  updatePaginationPackages,
  dispatch
) => {
  const cookies = new Cookies();
  const token = cookies.get(TOKEN_NAME);
  const params = {
    filter: buildFirstLevelFilterPoolExport(
      filterValues?.pickupDateRange?.length > 0
        ? {
            ...filterValues,
            startPickupDate: filterValues.pickupDateRange[0],
            endPickupDate: filterValues.pickupDateRange[1]
          }
        : {
            ...filterValues
          }
    ),
    page,
    pageSize
  };
  const config = {
    responseType: "json",
    headers: { Authorization: `Bearer ${token}` },
    params
  };
  await getPackageV2List(
    config,
    params,
    setAxiosPackageList,
    updatePaginationPackages,
    dispatch
  );
};

const getPackageV2List = (
  config,
  params,
  setAxiosPackageList,
  updatePaginationPackages,
  dispatch
) => {
  console.log("🔍 [DEBUG FRONTEND] getPackageV2List called");
  console.log("🔍 [DEBUG FRONTEND] Request params:", params);
  console.log("🔍 [DEBUG FRONTEND] Request config:", config);

  axios
    .get(`${baseURL}/orderv2/all-packages`, config, { params })
    .then((response) => {
      console.log("🔍 [DEBUG FRONTEND] Response received:", response);
      console.log("🔍 [DEBUG FRONTEND] Response data:", response.data);
      console.log("🔍 [DEBUG FRONTEND] Response metadata:", response.data.metadata);
      console.log(
        "🔍 [DEBUG FRONTEND] Response data array length:",
        response.data.data?.length
      );

      dispatch(updatePaginationPackages(response.data.metadata));
      setAxiosPackageList(response.data.data);
    })
    .catch((error) => {
      console.log("❌ [ERROR FRONTEND] Error fetching packages:", error);
    });
};
